import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { AppBar, Container, Toolbar } from '@mui/material';
import { logout } from '../../../actions/security';
import { updateUser, updateUserWithSignature } from '../../../actions/user';
import HeaderDesktop from './HeaderDesktop';
import HeaderMobile from './HeaderMobile';

const Header = () => {
  const dispatch = useDispatch();

  const [dimensions, setDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const handleResize = () => {
    setDimensions({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize, false);
  }, []);

  const securityReducer = useSelector((state) => state.security);
  const { validToken, loggedUser } = securityReducer;
  const isUserAuthenticated = validToken && loggedUser ? true : false;

  const userReducer = useSelector((state) => state.user);
  const { user } = userReducer;

  const [anchorElNav, setAnchorElNav] = useState(null);

  const [showUpdateUserModal, setShowUpdateUserModal] = useState(false);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const showUpdateModal = () => {
    setShowUpdateUserModal(true);
  };

  const handlePreviewClose = () => {
    setShowUpdateUserModal(false);
  };

  const logoutUser = () => {
    dispatch(logout());
    window.location.href = '/';
  };

  const handleEdit = (user) => {
    dispatch(updateUserWithSignature(user, handlePreviewClose));
  };

  return (
    <AppBar position="static" className="heed" sx={{ bgcolor: '#0d2a4a' }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters style={{ alignItems: 'normal' }}>
          {dimensions.width > 902 ? (
            <HeaderDesktop
              anchorElNav={anchorElNav}
              isUserAuthenticated={isUserAuthenticated}
              handleEdit={handleEdit}
              handleOpenNavMenu={handleOpenNavMenu}
              handleCloseNavMenu={handleCloseNavMenu}
              loggedUser={loggedUser}
              logoutUser={logoutUser}
              showUpdateModal={showUpdateModal}
              showUpdateUserModal={showUpdateUserModal}
              setShowUpdateUserModal={setShowUpdateUserModal}
              user={user}
            />
          ) : (
            <HeaderMobile
              anchorElNav={anchorElNav}
              isUserAuthenticated={isUserAuthenticated}
              handleEdit={handleEdit}
              handleOpenNavMenu={handleOpenNavMenu}
              handleCloseNavMenu={handleCloseNavMenu}
              loggedUser={loggedUser}
              logoutUser={logoutUser}
              showUpdateModal={showUpdateModal}
              showUpdateUserModal={showUpdateUserModal}
              user={user}
            />
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
};
export default Header;
